<template>
  <div class="header">
    <div class="head_wrap clearfix">
      <div class="logo">
        <img src="~@img/logo3.png" alt="logo" width="40">
        <span>Teacher Application Portal</span>
      </div>

      <div class="user_msg" v-if="is_logined !== null">
        <a :href="urls.naFaq" target="_blank">FAQ</a>
        <el-dropdown v-if='is_logined'>
          <span class="el-dropdown-link">
            My Account
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu class="account-menu" slot="dropdown">
            <el-dropdown-item @click.native="$router.push('/resetcode')">Change Password</el-dropdown-item>
            <el-dropdown-item @click.native='signOut'>Sign Out</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <a v-else :href='direction'>Sign in</a>
      </div>
    </div>
  </div>
</template>
<script>
import { urls } from '@js'

export default {
  data() {
    return {
      show: false,
      direction: '',
      urls
    }
  },
  props: {},
  methods: {
    signOut() {
      this.$http.get('/index/logout').then(function(d) {
        if (d.data.code == '75000' && d.data.res) {
          window.location.href = urls.ssoLogout
        } else {
          this.$message.error('retry.')
        }
      })
    }
  },
  computed: {
    is_logined() {
      console.log(this.$store.state.is_logined)
      return this.$store.state.is_logined
    }
  },
  created() {
    let uri = window.location.origin.replace(/http.+\/\//, '')
    switch (uri) {
      case 'mypage.us.51talk.com':
        this.direction = urls.ssoUsLogin
        break
      case 'mypage.51talk.com':
        this.direction = urls.ssoLogin
        break
      default:
        console.log('Sign in match error!')
    }
  }
}
</script>
<style lang='less'>
.header {
  background: #fcc800;
}
div.head_wrap {
  width: 1000px;
  height: 44px;
  vertical-align: middle;
  margin: 0 auto;

  .logo {
    float: left;
    color: #221714;
    padding-top: 2px;

    img,
    span {
      display: inline-block;
      vertical-align: middle;
    }

    span {
      border-left: 1px solid #967100;
      margin-left: 10px;
      padding-left: 14px;
      line-height: 20px;
      height: 20px;
    }
  }
}
div.user_msg {
  position: relative;
  float: right;
  padding-top: 15px;
  & > a,
  .el-dropdown {
    display: inline-block;
    vertical-align: middle;
    padding: 0 15px;
    font-size: 16px;
    color: #403d3c;
    cursor: pointer;
    height: 20px;
    line-height: 20px;
    border-right: 1px solid #967100;

    .el-icon--right {
      font-size: 14px;
    }
  }
}

.account-menu {
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// header.vue?31843f5b